import { t } from '../i18n';

/**
 * Bronvermelding bij een beeld uit een externe collectie: media-item met `credit`
 * (bv. "Made in Aalst – stadsarchief Aalst, collectie François M.") en optioneel `credit_url`.
 */
export function mediaCredit(item, className) {
  if (!item || !item.credit) return null;
  const text = item.credit_url ? (
    <a href={item.credit_url} target="_blank" rel="noopener noreferrer" onclick={(e) => e.stopPropagation()}>
      {item.credit}
    </a>
  ) : (
    item.credit
  );

  return (
    <span className={className}>
      {t('common.source')}: {text}
    </span>
  );
}
